import React , {useState} from 'react';
import PropTypes from 'prop-types';
import './styles.scss'
import AboutItem from './about-item';
import './styles.scss';


About.propTypes = {
    data : PropTypes.array,
};

function About(props) {

    const {data} = props;

    const [dataBlock] = useState(
        {
            subtitle : 'Built on Bitcoin',
            title: 'A sharper pirate myth for Ordinals collectors',
            desc : 'Block Pirates is a 10,000-piece Chimp collection that blends collectible character art with the permanence of Bitcoin inscriptions. The project is built around rarity, personality, and a simple promise: make the collection feel fun to own today and meaningful to look back on years from now.'
        }
    )

    return (
        <section className="tf-section tf-about">
            <div className="container">
                <div className="row">
                    <div className="col-xl-5 col-md-12">
                        <div className="content-about mobie-40" data-aos="fade-up" data-aos-duration="800">
                            <div className="tf-title st2">
                                <p className="h8 sub-title">{dataBlock.subtitle}</p>
                                <h4 className="title">{dataBlock.title}</h4>
                            </div>
                            
                            <p>{dataBlock.desc}</p>
                            

                           

                           

                        <a className="bp-button bp-button--primary" href="https://www.satflow.com/ordinals/blockpirates" target="_blank" rel="noreferrer">
                            View Marketplace
                        </a>

                        <div></div>

                       

                    

                      
                        
                    


                    
                        



                        

                        </div>
                    </div>
                    <div className="col-xl-7 col-md-12">
                        <div className="wrap-about" data-aos="fade-up" data-aos-duration="800">
                            {
                                data.map(item => (
                                    <AboutItem key={item.id} item={item} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;

//Redeploy the buttons to line

/*
 <Button title='Mint here' path="#"/> 


<Button title='OpenSea' path='#https://opensea.io/collection/blockchainpirates-eth' />

*/

/*

 <a href="https://presale.magiceden.io/pay/68854eb64a31085f7a965611">
                        <button class="mintBtn"> MINT </button> 
                        
                        </a>

*/
